import {createContext, ReactElement} from "react";

export type DialogInput = {
    title?: string
    contents: ReactElement | string
}

export const isDialogInput = (value: unknown): value is DialogInput =>
    typeof value == "object" && value !== null && "description" in value

export type FeedbackContextType = {
    success?: (msg: string) => void
    warning?: (msg: string) => void
    error?: (msg: string) => void
    confirm?: (input: DialogInput | DialogInput["contents"]) => Promise<boolean>
    info?: (input: DialogInput | DialogInput["contents"]) => void
}

export const FeedbackContext = createContext<FeedbackContextType>({})
